import { CALL_API } from '../middleware/ApiMiddleware';

export const AGENCY_PREFERENCES_FETCH_REQUEST = 'AGENCY_PREFERENCES_FETCH_REQUEST';
export const AGENCY_PREFERENCES_FETCH_SUCCESS = 'AGENCY_PREFERENCES_FETCH_SUCCESS';
export const AGENCY_PREFERENCES_FETCH_FAILURE = 'AGENCY_PREFERENCES_FETCH_FAILURE';
export const AGENCY_PREFERENCES_EDIT_REQUEST = 'AGENCY_PREFERENCES_EDIT_REQUEST';
export const AGENCY_PREFERENCES_EDIT_SUCCESS = 'AGENCY_PREFERENCES_EDIT_SUCCESS';
export const AGENCY_PREFERENCES_EDIT_FAILURE = 'AGENCY_PREFERENCES_EDIT_FAILURE';

export const fetchAgencyPreferences = () => ({
  [CALL_API]: {
    endpoint: 'agencies-preferences',
    method: 'get',
    authenticated: true,
    types: [AGENCY_PREFERENCES_FETCH_REQUEST, AGENCY_PREFERENCES_FETCH_SUCCESS, AGENCY_PREFERENCES_FETCH_FAILURE],
  },
});

export const editAgencyPreferences = (contactPreferenceNote: string) => ({
  [CALL_API]: {
    endpoint: 'agencies-preferences',
    method: 'put',
    body: { contactPreferenceNote },
    authenticated: true,
    types: [AGENCY_PREFERENCES_EDIT_REQUEST, AGENCY_PREFERENCES_EDIT_SUCCESS, AGENCY_PREFERENCES_EDIT_FAILURE],
  },
});
